import React, { useState, useEffect, useRef } from "react";
import { Volume2, Pause, Play, Square } from "lucide-react";

const stripHtml = (html) => {
  const doc = new DOMParser().parseFromString(html || "", "text/html");
  return (doc.body.textContent || "").replace(/\s+/g, " ").trim();
};

const ArticleAudio = ({ title, html }) => {
  const [supported, setSupported] = useState(true);
  const [state, setState] = useState("idle"); // idle | playing | paused
  const utterRef = useRef(null);

  useEffect(() => {
    if (typeof window === "undefined" || !("speechSynthesis" in window)) {
      setSupported(false);
    }
    return () => {
      try { window.speechSynthesis.cancel(); } catch (e) { console.debug("speechSynthesis cancel failed", e); }
    };
  }, []);

  const play = () => {
    const synth = window.speechSynthesis;
    if (state === "paused") { synth.resume(); setState("playing"); return; }
    synth.cancel();
    const u = new SpeechSynthesisUtterance(`${title}. ${stripHtml(html)}`);
    u.rate = 1; u.pitch = 1;
    const voices = synth.getVoices();
    const en = voices.find((v) => /en[-_]US/i.test(v.lang)) || voices.find((v) => /^en/i.test(v.lang));
    if (en) u.voice = en;
    u.onend = () => setState("idle");
    u.onerror = () => setState("idle");
    utterRef.current = u;
    synth.speak(u);
    setState("playing");
  };

  const pause = () => { window.speechSynthesis.pause(); setState("paused"); };
  const stop = () => { window.speechSynthesis.cancel(); setState("idle"); };

  if (!supported) return null;

  return (
    <div className="article-audio" data-testid="article-audio">
      <span className="article-audio-label"><Volume2 size={15} /> Listen to this article</span>
      <div className="article-audio-controls">
        {state !== "playing" ? (
          <button className="audio-btn" onClick={play} data-testid="audio-play">
            <Play size={14} /> {state === "paused" ? "Resume" : "Play"}
          </button>
        ) : (
          <button className="audio-btn" onClick={pause} data-testid="audio-pause">
            <Pause size={14} /> Pause
          </button>
        )}
        {state !== "idle" && (
          <button className="audio-btn audio-btn-ghost" onClick={stop} data-testid="audio-stop">
            <Square size={12} /> Stop
          </button>
        )}
      </div>
    </div>
  );
};

export default ArticleAudio;
